// removed by extract-text-webpack-plugin
module.exports = {"contact":"MUSCBg5SO9RyW7b6a22E3","lineBreak":"_1-HCRu-BZeqVxbFtt5IDxI","email":"_2Sy6I-CZL7EwKO70FaxtRg","link":"_3VcCHGBksj6LvZP8feUcaR","social":"_1Cft6wFoQ4s9teTcv2JSuk"};


//////////////////
// WEBPACK FOOTER
// ../components/contact/styles.module.css
// module id = 734
// module chunks = 0